import apps from '../vars/vars.json'
export default {
    V (data) {
        return apps[data]
    }
}